import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';
import Select from '../../../Part_Sample/Select';
import ConfirmMessage from '../../../Part_Sample/ConfirmMessage';

export default class Add_Edit_Site extends Component {
	constructor(props) {
		super(props);

		let site_info = {
			mac: '',
			account: '', 	// username for login to controller
			passwd: '', 	// password for login to controller
			name: '', 		// site name
			location: '',	// site location
			size: '',		// floor size
			temp_targ: '', 	// point_id
			val_targ: '',	// point_id
		};

		if (this.props.param.site_info != null && this.props.param.site_id != null) {
			site_info = JSON.parse(JSON.stringify(this.props.param.site_info));
		}

		if (!isEmpty(this.props.param.controller_info)) {
			site_info.mac = this.props.param.controller_info.mac_addr;
			site_info.name = this.props.param.controller_info.name;
		}

		this.state = {
			site_info: site_info,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('MSM_Settings_Sites');
	}

	handleChangeSiteName = (val) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.name = val;
		this.setState({ site_info: site_info });
	}

	handleChangeMacAddress = (val) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.mac = val;
		this.setState({ site_info: site_info });
	}

	handleChangeUsername = (val) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.account = val;
		this.setState({ site_info: site_info });
	}

	handleChangePassword = (val) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.passwd = val;
		this.setState({ site_info: site_info });
	}

	handleChangeLocation = (val) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.location = val;
		this.setState({ site_info: site_info });
	}

	handleChangeSize = (val) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.size = val;
		this.setState({ site_info: site_info });
	}

	handleChangeTempTarget = (point_id) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.temp_targ = point_id;
		this.setState({ site_info: site_info });
	}

	handleChangeValueTarget = (point_id) => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info));
		site_info.val_targ = point_id;
		this.setState({ site_info: site_info });
	}

	activateQRScanner = () => {
		document.getElementById('qr').classList.add('fadeIn');
		let param = this.props.param;
		param.from = 'Add_Edit_Site';
		param.original_from = 'MSM_Settings_Sites';
		param.site_info = this.state.site_info;
		this.props.content_handler('QR_Scanner', param);
	}

	handleRegister = () => {
		let site_info = JSON.parse(JSON.stringify(this.state.site_info))

		if (site_info.mac == '' || site_info.mac == null) {
			window.app.showToast(this.props.receiver.getString('no_mac'), 3000, 60);
			return;
		} else if (site_info.name == '') {
			window.app.showToast(this.props.receiver.getString('no_site_name'), 3000);
			return;
		} else if (site_info.account == '') {
			window.app.showToast(this.props.receiver.getString('no_username'), 3000);
			return;
		} else if (site_info.passwd == '') {
			window.app.showToast(this.props.receiver.getString('no_password'), 3000);
			return;
		}

		if (site_info.size == '') {
			delete site_info.size;
		} else {
			site_info.size = parseFloat(site_info.size);
		}

		if (site_info.temp_targ == '') delete site_info.temp_targ;
		if (site_info.val_targ == '') delete site_info.val_targ;

		window.app.showLoading();
		if (this.props.param.site_id == null) {
			this.props.receiver.addMSMSite(site_info);
		} else {
			this.props.receiver.modifyMSMSite([this.props.param.site_id, site_info]);
		}
	}

	handleDelete = () => {
		window.app.showLoading();
		this.props.receiver.deleteMSMSite(this.props.param.site_id);
	}

	rcvMSMAddSite = (response) => {
		window.app.hideLoading();
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'MSM_Settings_Sites';
			this.props.receiver.getMSMSiteList();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvMSMModifySite = (response) => {
		window.app.hideLoading();
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'MSM_Settings_Sites';
			this.props.receiver.getMSMSiteList();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvMSMDeleteSite = (response) => {
		window.app.hideLoading();
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'MSM_Settings_Sites';
			this.props.receiver.getMSMSiteList();
		} else {
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let temp_targ_selection = [];
		let value_targ_selection = [];

		temp_targ_selection.push(<option value={''} key={'temp-nil'}>{this.props.receiver.getString('none')}</option>)
		value_targ_selection.push(<option value={''} key={'val-nil'}>{this.props.receiver.getString('none')}</option>)

		for (let temp_point_id in this.props.param.temp_targ_list) {
			let temp_name = this.props.param.temp_targ_list[temp_point_id];
			temp_targ_selection.push(<option value={temp_point_id} key={temp_point_id}>{temp_name}</option>)
		}

		for (let val_point_id in this.props.param.val_targ_list) {
			let val_name = this.props.param.val_targ_list[val_point_id];
			value_targ_selection.push(<option value={val_point_id} key={val_point_id}>{val_name}</option>)
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.site_id != null ? this.props.receiver.getString('edit_site') : this.props.receiver.getString('add_site')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={this.props.receiver.is_mobile ? 'qr' : null}
						handleRightButton={this.activateQRScanner}
					/>
					<div style={{ marginTop: 10 }}>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='site_name' style={{}} placeholder={this.props.receiver.getString('site_name')} inputType='text' onChange={(event) => this.handleChangeSiteName(event.target.value)} value={this.state.site_info.name} />
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='username' placeholder={this.props.receiver.getString('usrname')} inputType='text' onChange={(event) => this.handleChangeUsername(event.target.value)} value={this.state.site_info.account} />
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='passwd' placeholder={this.props.receiver.getString('passwd')} inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.site_info.passwd} />
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='location' placeholder={this.props.receiver.getString('site_location')} inputType='text' onChange={(event) => this.handleChangeLocation(event.target.value)} value={this.state.site_info.location} />
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='size' placeholder={this.props.receiver.getString('floor_area')} inputType='number' onChange={(event) => this.handleChangeSize(event.target.value)} value={this.state.site_info.size} />
						</div>
						<div style={{ marginTop: 20, display: this.props.param.site_id == null ? 'none' : 'block' }}>
							<div id='temp_target' style={{ marginLeft: 10, textAlign: 'left' }}>
								<div style={{ display: 'inline-block', width: this.props.width - 200, verticalAlign: 'top' }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('temp')}</span>
								</div>
								<div style={{ display: 'inline-block', width: 180 }}>
									<Select
										style={{ display: 'inline-block' }}
										select_style={{ fontSize: 16, height: 35 }}
										options={temp_targ_selection}
										value={this.state.site_info.temp_targ}
										onSelect={this.handleChangeTempTarget}
									/>
								</div>
							</div>
							<div style={{ marginTop: 20 }}>
								<div id='value_target' style={{ marginLeft: 10, textAlign: 'left' }}>
									<div style={{ display: 'inline-block', width: this.props.width - 200, verticalAlign: 'top' }}>
										<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('value_target')}</span>
									</div>
									<div style={{ display: 'inline-block', width: 180 }}>
										<Select
											style={{ display: 'inline-block' }}
											select_style={{ fontSize: 16, height: 35 }}
											options={value_targ_selection}
											value={this.state.site_info.val_targ}
											onSelect={this.handleChangeValueTarget}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}